// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicPages_container__2_IvP"};